import { useEffect, useRef, useState } from "react";

import uploadAndDownloadService from "../../services/uploadAndDownloadFile";

const Predection = () => {
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [predectionImage, setPredectionImage] = useState();

  const myRefs = useRef(null);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  useEffect(() => {
    let imageUrl = "/retail/uploadFile/fileERP/predection/my_plot.png";
    uploadAndDownloadService
      .downloadFile(imageUrl)
      .then((response) => {
        let index = imageUrl.lastIndexOf(".");
        let extension = imageUrl.substr(index + 1);

        //Build a URL from the file

        let base64ImageString = Buffer.from(response.data, "binary").toString(
          "base64"
        );

        let image = "data:image/png;base64," + base64ImageString;
        setPredectionImage(image);

        //  myRefs.current.src = image;
      })
      .catch(() => {});
  }, []);

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <img src={predectionImage} style={{ marginTop : "-20px" ,width : "1200px" , height: "600px" }}></img>
                </div>
              </div>
            </div>
            {/* <img
                alt="Remy Sharp"
               
                // ref={myRefs}
                class="rounded-circle"
                style={{ width: "100px", height: "100px" }}
              ></img> */}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Predection;
